import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanyWarningRegular from './company-warning-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CompanyWarningRegular {...props} />;
}

SvgComponent.iconName = 'companyWarningRegular';

export const CompanyWarningRegularIcon = svgIconWrapper(SvgComponent);
